import React from 'react';

import {
  Box,
  SimpleGrid,
  Text,
  Icon,
  Collapse,
  Badge,
  HStack,
} from '@chakra-ui/react';
import { FaSearch, FaShieldAlt } from 'react-icons/fa';

import { VERIFIED_EBAY_SELLER } from '../constants/defaultItemSpecsConfig';
import { useColors } from './colors';

const PANELS = [
  {
    id: 'seller',
    label: 'Verified eBay reference seller',
    description: `Verified listing data source: ${VERIFIED_EBAY_SELLER.username}`,
    icon: FaShieldAlt,
    accentColor: 'blue.500',
    activeBorderColor: 'blue.400',
    badge: (
      <Badge colorScheme="blue" variant="subtle" fontSize="xs">
        Verified
      </Badge>
    ),
  },
  {
    id: 'lookup',
    label: 'SKU lookup',
    description: 'Search a canonical SKU to review catalog and optimizer history',
    icon: FaSearch,
    accentColor: 'teal.500',
    activeBorderColor: 'teal.400',
  },
];

const TopInfoSectionCard = ({ activePanel, onPanelChange, children }) => {
  const { textColor, backgroundCardColor, borderColor, secondaryTextColor, mutedBg } = useColors();

  const handleTabClick = (id) => {
    onPanelChange(activePanel === id ? null : id);
  };

  return (
    <Box>
      <Box
        p={4}
        bg={backgroundCardColor}
        borderRadius="lg"
        borderWidth="1px"
        borderColor={borderColor}
        boxShadow="sm"
      >
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
          {PANELS.map((panel) => {
            const isActive = activePanel === panel.id;
            return (
              <Box
                key={panel.id}
                as="button"
                type="button"
                onClick={() => handleTabClick(panel.id)}
                p={4}
                textAlign="left"
                borderRadius="md"
                borderWidth="2px"
                borderColor={isActive ? panel.activeBorderColor : borderColor}
                bg={isActive ? mutedBg : backgroundCardColor}
                transition="all 0.2s"
                _hover={{
                  borderColor: panel.activeBorderColor,
                  transform: 'translateY(-1px)',
                  boxShadow: 'sm',
                }}
                cursor="pointer"
                w="full"
              >
                <HStack spacing={3} align="flex-start" mb={2}>
                  <Icon
                    as={panel.icon}
                    boxSize={5}
                    color={isActive ? panel.accentColor : secondaryTextColor}
                    mt={0.5}
                  />
                  <Box flex={1}>
                    <HStack spacing={2} flexWrap="wrap">
                      <Text
                        color={textColor}
                        fontSize="sm"
                        fontWeight="semibold"
                        lineHeight="short"
                      >
                        {panel.label}
                      </Text>
                      {panel.badge}
                    </HStack>
                  </Box>
                </HStack>
                <Text color={secondaryTextColor} fontSize="xs" lineHeight="short" pl={8}>
                  {panel.description}
                </Text>
              </Box>
            );
          })}
        </SimpleGrid>
      </Box>

      <Collapse in={Boolean(activePanel)} animateOpacity>
        <Box mt={4}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default TopInfoSectionCard;
